import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component({})
export default class BaseForm extends Vue {
  onSubmitHandler(data: any) {
    this.$emit('form:submit')
  }

  onCancelHandler(data: any) {
    this.$emit('form:cancel')
  }
}
